import React from "react";
import { Grid } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import { Mapping, Timezone } from "pages/dashboard/admin/import/interest_imports/types";
import { Viewer } from "components/auth/types";
import { Problem } from "pages/dashboard/admin/import/interest_imports/validate";
import { SettingsHeader } from "../settings-header";
import StepUpload from "./steps/step-0-upload";
import StepOrganize from "./steps/step-1-organize";
import StepMatch from "./steps/step-2-match";
import StepValidate from "./steps/step-3-validate";
import StepErrors from "./steps/step-4-errors";
import StepFinalize from "./steps/step-5-finalize";
import StepSuccess from "./steps/step-6-success";
import StepNavigation from "./components/step-navigation";
import BreadcrumbNavigator from "./components/breadcrumb-navigator";
import { StepProvider } from "./context";

export type StepData = Record<string, any> & {
  file: File | null;
  files: File[];
  data: Record<string, any>[];
  mapping: Mapping;
  timezone: Timezone;
  validateOrder: boolean;
  problems: Problem[];
  listId?: string;
};

export type StepProps = Record<string, any>

export const availableSteps = ["Upload", "Organize", "Match", "Validate", "Errors", "Finalize", "Confirmation"] as const;
type Props = {
  viewer: Viewer;
}

export const initialStepData: StepData = {
  file: null,
  files: [],
  data: [],
  mapping: {},
  timezone: "none",
  validateOrder: true,
  problems: [],
};

const ImportsPage: React.FC<Props> = ({ viewer }) => {
  if (!viewer) return null;
  if (!viewer.lists) return null;
  if (!viewer.lists.length) return null;

  return (
    <div>
      <div>
        <SettingsHeader title="Imports" />
        <StepProvider viewer={viewer}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <BreadcrumbNavigator>
                <Routes>
                  <Route path="upload" element={<StepUpload />} />
                  <Route path="organize" element={<StepOrganize />} />
                  <Route path="match" element={<StepMatch />} />
                  <Route path="validate" element={<StepValidate />} />
                  <Route path="errors" element={<StepErrors />} />
                  <Route path="finalize" element={<StepFinalize />} />
                  <Route path="success" element={<StepSuccess />} />
                </Routes>
              </BreadcrumbNavigator>
            </Grid>
            <StepNavigation />
          </Grid>
        </StepProvider>
      </div>
    </div>
  );
};

export default ImportsPage;
